import { FETCH_SUMMARY_DATA, FETCH_GOOGLE_ANALYTICS_DATA } from "../types";

const initialState = {
  loading: false,
  message: null,
  data: {},
};

export const summaryDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_SUMMARY_DATA}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_SUMMARY_DATA}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.data ? action.payload.data.results : {},
        message: action.payload?.message || action.payload.data?.message || "",
      };

    case `${FETCH_SUMMARY_DATA}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const googleAnalyticsDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_GOOGLE_ANALYTICS_DATA}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_GOOGLE_ANALYTICS_DATA}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.data ? action.payload.data.results : {},
        message: action.payload.data?.message || "",
      };

    case `${FETCH_GOOGLE_ANALYTICS_DATA}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};
